import { useFetchContainerSizesQuery } from '@api/Trinium/Endpoints/Lookups/slice';
import { ContainerSize } from '@api/Trinium/Endpoints/Lookups/types';
import DisabledTooltip from '@components/DisabledTooltip';
import { FormikButtonDropdown } from '@forms/Components/Dropdowns/ButtonDropdown';
import PopupList from '@forms/Components/Dropdowns/List';
import { Field, useFormikContext } from 'formik';
import { FormikAutocomplete } from '@forms/Components/AutocompleteInput';

import styles from '../Components/Form.module.css';

interface ContainerSizeDropdownProps {
	fieldName: string;
	className?: string;
	isDisabled?: boolean;
	disabledReason?: string;
	disabledTooltipClass?: string;
	isRequired?: boolean;
}

export default function ContainerSizeDropdownField(props: ContainerSizeDropdownProps) {
	const { getFieldMeta, setFieldValue, setFieldTouched } = useFormikContext();
	const { value } = getFieldMeta<string>(props.fieldName);

	const { data: sizes } = useFetchContainerSizesQuery(undefined);

	return (
		<DisabledTooltip
			message={props.isDisabled ? props.disabledReason : undefined}
			className={props.disabledTooltipClass}
		>
			<Field
				name={props.fieldName}
				label='Size'
				component={FormikButtonDropdown({
					ButtonContent: () => <span>{value || 'Select Size'}</span>,
					buttonContentProps: {},
					PopupContent: PopupList,
					popupContentProps: {
						items: sizes ?? [],
						getItemDisplay: (item: ContainerSize) => item.size,
						onItemSelect: (value: ContainerSize) => {
							void setFieldTouched(props.fieldName, true);
							void setFieldValue(props.fieldName, value.size, true);
						},
						className: styles['list-box-sm']
					}
				})}
				className={props.className}
				disabled={props.isDisabled}
				required={props.isRequired}
			/>
		</DisabledTooltip>
	);
}

export function ContainerSizeAutocompleteField({ fieldName, ...props }: ContainerSizeDropdownProps) {
	const { data: sizes } = useFetchContainerSizesQuery(undefined);

	return (
		<Field
			name={fieldName}
			label='Size'
			placeholder='Enter Size'
			component={FormikAutocomplete}
			className={props.className}
			autoCompleteItems={sizes?.map((s) => s.size) ?? []}
			disabled={props.isDisabled}
			required={props.isRequired}
		/>
	);
}
